
import {utils} from "mc/lib";
const {ErrorApi, JsonFetch, Fetch, ParamsFetch} = utils;

import {generateUrl} from "mc/lib/utils";

/**
 * Serviska pro práci s poukazy. Generated from cz.marbes.api.es.banka.BankaPoukazService.
 */
export default class BankaPoukazApi {
    /**
     * Vygenerování dokumentu poukazu.
     *
     * @param poukazHlavickaId id hlavičky poukazu
     * @return PDF dokument
     */
    static getDokumentPoukazu(poukazHlavickaId : number) : String {
        const uri = serverContextPath + `/api/banka/vratka/bankovni/doklad/${poukazHlavickaId}`;
        const params = {  };
        return generateUrl(uri, params, true);
    }

}